import {
  PaymentProviders,
  VendorProfileTemplate,
  VendorProfileTemplateType,
} from '../../../types/shared/Account';
import {
  FormDefinition,
  SignupFormDefinition,
} from '../../../types/shared/FormDefinition';
import {
  ID_FIELD_NAME,
  ID_FIELD_CONTACT,
  ID_FIELD_EMAIL,
  ID_FIELD_MARKETS,
  ID_FIELD_CATEGORY,
  DefaultSignupForm,
} from '../../../core/constants/SignupForm';

// TODO: Remove these exports
export {
  DEFAULT_MARKET_PAYMENTS,
  DEFAULT_MARKET_NOTE_CATEGORIES,
} from '../../../core/constants/Sales';

export class Constant {}

export const LOADING = new Constant();

// Freshbooks API OAuth
export const FRESHBOOKS_CLIENT_ID =
  '1e08f86f2956ed55ae9a3b0671a9e03ed2e8d89795e2dedd22188b531c8b8cc2';
export const FRESHBOOKS_REDIRECT_PATHNAME = `/oauth/freshbooks/landing`;

// Quickbooks API OAuth
// const QUICKBOOKS_CLIENT_ID_DEV =
//   'Q0o9pWjvJlJkWGiwjy67m7ixjMGxHTGfvt54ZFPvXygv9brANj';
const QUICKBOOKS_CLIENT_ID_PROD =
  'Q0RNPeikSdWbDV29eGpLBBIFm8OSss73MvZJNvwZ6QkkdXOZPF';

export const QUICKBOOKS_CLIENT_ID = QUICKBOOKS_CLIENT_ID_PROD;
export const MARKETWURKS_TAX = 'MarketWurks Tax Non-US';

export const QUICKBOOKS_REDIRECT_PATHNAME = `/oauth/quickbooks/landing`;

// Stripe API OAuth
// const STRIPE_API_KEY_DEV = 'pk_test_6FDUkgUBzBrszEeWuBQWGN7I';
const STRIPE_API_KEY_PROD = 'pk_live_jR35gCnL7WU3KPgP41k252bo';

export const STRIPE_API_KEY = STRIPE_API_KEY_PROD;

// const STRIPE_CLIENT_ID_DEV = 'ca_Do1C5zGChfRngqn67dBcmWErhmcpsv57';
const STRIPE_CLIENT_ID_PROD = 'ca_Do1ClTHav0zVvUiTEloDItjkD567A0TT';

export const STRIPE_CLIENT_ID = STRIPE_CLIENT_ID_PROD;
export const STRIPE_REDIRECT_PATHNAME = `/oauth/stripe/landing`;

export const ID_FIELD_DAILY_AT_MARKET_TRANSACTIONS =
  '0003f6bfe944972d4e1962d08dddeec2';

export const APP_FIELDS = {
  ID_FIELD_NAME,
  ID_FIELD_CONTACT,
  ID_FIELD_EMAIL,
  ID_FIELD_MARKETS,
  ID_FIELD_CATEGORY,
};

export const APP_FIELDS_BY_ID = {
  [ID_FIELD_NAME]: true,
  [ID_FIELD_CONTACT]: true,
  [ID_FIELD_EMAIL]: true,
  [ID_FIELD_MARKETS]: true,
  [ID_FIELD_CATEGORY]: true,
};

export const APP_FIELDS_CAN_HIDE = {
  [ID_FIELD_NAME]: true,
  [ID_FIELD_CONTACT]: true,
  [ID_FIELD_MARKETS]: true,
  [ID_FIELD_CATEGORY]: true,
};

export const APP_FIELDS_INDEXED = {
  name: ID_FIELD_NAME,
  contact: ID_FIELD_CONTACT,
  email: ID_FIELD_EMAIL,
  category: ID_FIELD_CATEGORY,
};

export const DEFAULT_SIGNUP_FORM_ID = 'signup';

type FormDefaults = {
  signup: SignupFormDefinition;
  evaluation: FormDefinition;
  default: FormDefinition;
};

export const DEFAULT_FORMS: FormDefaults = {
  signup: DefaultSignupForm,
  evaluation: {
    id: 'evaluation',
    name: 'Market Reporting',
    fields: [],
    revision: 0,
  },
  default: {
    id: 'default',
    name: 'Default Form',
    fields: [],
    revision: 0,
  },
};

export const DEFAULT_FORM_REVISIONS = {
  id: '',
  revisions: [],
};

export const DEFAULT_CURRENCY = 'USD';

export const FEE_OPTIONS = ['percentage', 'fixed'];

export const INVOICE_PROVIDERS = {
  freshbooks: 'freshbooks',
  quickbooks: 'quickbooks',
};

export const DEFAULT_INVOICE_PROVIDER = INVOICE_PROVIDERS.freshbooks;
export const DEFAULT_PAYMENT_PROVIDER: PaymentProviders = 'stripe';

export const DEFAULT_PROFILE_TEMPLATE_TYPE: VendorProfileTemplateType =
  'horizontalCardSquare';

export const DEFAULT_VENDOR_PROFILE_TEMPLATE: VendorProfileTemplate = {
  type: DEFAULT_PROFILE_TEMPLATE_TYPE,
  nameID: ID_FIELD_NAME,
  descriptionID: ID_FIELD_NAME,
};

export const DEFAULT_APPROVAL_EMAIL_CONTENT = `Congratulations you've been approved`;
export const DEFAULT_APPROVAL_EMAIL_SUBJECT = `Congratulations you've been approved`;

export const DEFAULT_SETTINGS = {
  invoice_provider: DEFAULT_INVOICE_PROVIDER,
  payment_provider: DEFAULT_PAYMENT_PROVIDER,
  approval_email: {
    subject: DEFAULT_APPROVAL_EMAIL_SUBJECT,
    emailContent: DEFAULT_APPROVAL_EMAIL_CONTENT,
  },
  declined_email: {
    subject: '',
    emailContent: '',
  },
  waitlisted_email: {
    emailContent: '',
    subject: '',
  },
  invoice_email: { emailContent: '', subject: '' },
  billing: {
    businessInfo: '',
  },
  alternative_payment: {
    enabled: true,
    content: 'Provide your custom payment instructions here',
  },
  embed_style: '',
  currency: DEFAULT_CURRENCY,
  vendorProfileTemplate: DEFAULT_VENDOR_PROFILE_TEMPLATE,
};

export const DEFAULT_VENDOR_LOCATION_OPTIONS = {
  defaultCenter: {
    lat: '-6.2596',
    lng: '106.6232359',
  },
  defaultCenterValidity: {
    lat: true,
    lng: true,
  },
  defaultZoom: (0 - 30) / 2,
  mapHeight: '200',
  showListView: true,
};

// This should not exceed what's allowed by the server or any proxy between the
// frontend and the server.
// TODO: Should we get this value from the server as part of `AppConfig`?
export const UPLOAD_MAX_SIZE = 20 * 1024 * 1024;

export const XHR_UNSENT = 0;
export const XHR_OPENED = 1;
export const XHR_HEADERS_RECEIVED = 2;
export const XHR_LOADING = 3;
export const XHR_DONE = 4;
